// src/components/planning/EditSelectionsModal/services/songSelectionsService.ts
import apiClient from '../../../../utils/apiClient';
import { SongSearchResult } from '../../types/planningTypes';

interface SongSearchResponse {
  songs: SongSearchResult[];
}

export const searchSongs = async (term: string): Promise<SongSearchResponse> => {
  try {
    const response = await apiClient.get<SongSearchResponse>('/song-selections/search', {
      params: { term }
    });
    return response.data;
  } catch (error) {
    console.error('Error searching songs:', error);
    throw error;
  }
};

// Add a new function to fetch single song details if needed
export const getSongDetails = async (songId: number): Promise<SongSearchResult> => {
  try {
    const response = await apiClient.get<{ song: SongSearchResult }>(`/song-selections/${songId}`);
    return response.data.song;
  } catch (error) {
    console.error('Error fetching song details:', error);
    throw error;
  }
};